import { Coins, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { CREDIT_EXHAUSTION_EVENT } from "./credit-exhaustion.js";

export function CreditExhaustionProvider({ children, creditsHref }) {
  const [open, setOpen] = useState(false);
  const dismissedRef = useRef(false);
  const creditsLinkRef = useRef(null);

  useEffect(() => {
    const show = () => {
      if (!dismissedRef.current) setOpen(true);
    };
    window.addEventListener(CREDIT_EXHAUSTION_EVENT, show);
    return () => window.removeEventListener(CREDIT_EXHAUSTION_EVENT, show);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const previouslyFocused = document.activeElement;
    creditsLinkRef.current?.focus();
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        dismissedRef.current = true;
        setOpen(false);
      }
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      window.removeEventListener("keydown", closeOnEscape);
      previouslyFocused?.focus?.();
    };
  }, [open]);

  const close = () => {
    dismissedRef.current = true;
    setOpen(false);
  };

  return (
    <>
      {children}
      {open ? (
        <div
          className="suite-modal-backdrop suite-credit-exhaustion-backdrop"
          role="presentation"
          onMouseDown={close}
        >
          <div
            className="suite-dialog suite-credit-exhaustion-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="suite-credit-exhaustion-title"
            aria-describedby="suite-credit-exhaustion-description"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="suite-icon-button suite-dialog-close"
              aria-label="Cerrar"
              onClick={close}
            >
              <X size={19} />
            </button>
            <span className="suite-dialog-icon suite-credit-exhaustion-icon">
              <Coins size={22} />
            </span>
            <h2 id="suite-credit-exhaustion-title">
              Te quedaste sin créditos
            </h2>
            <p id="suite-credit-exhaustion-description">
              Para continuar usando las funciones con inteligencia artificial,
              agregá más créditos desde tu cuenta.
            </p>
            <div className="suite-dialog-actions">
              <button
                type="button"
                className="suite-button suite-button--secondary"
                onClick={close}
              >
                Cerrar
              </button>
              <a
                ref={creditsLinkRef}
                className="suite-button suite-button--primary"
                href={creditsHref}
              >
                Agregar créditos
              </a>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
